<template>
  <fragment v-if="tags && Object.keys(tags).length">
    <template v-for="(tag, qId, index) in tags">
      <div
        :key="index"
        v-if="Object.keys(tag.variables).length"
        class="d-inline mx-1"
      >
        <span>{{ tag.label }}:</span>
        <template v-for="(variable, vId, i) in tag.variables">
          <span
            v-if="tag.type === 'DERIVED'"
            :key="i"
            class="rounded_50 v2_bg_primary_teal v2_color_white px-2 d-inline-flex align-items-center m-1"
          >
            <span class="text-nowrap">
              <template v-if="variable.prefix">{{ variable.prefix }}</template>
              <template v-if="variable.label">{{ variable.label }}</template>
              <template v-if="variable.suffix">{{ variable.suffix }}</template>
            </span>
            <i
              class="mdi mdi-close-circle-outline pl-1 v2_font_size_18 clickable"
              @click="onRemoveTagClick(qId, vId, true)"
            />
          </span>
          <span
            v-else
            :key="i"
            class="rounded_50 v2_bg_primary_teal v2_color_white px-2 d-inline-flex align-items-center m-1"
          >
            <span class="text-nowrap">
              <template v-if="variable.label">{{ variable.label }}: </template>
              <template v-if="variable.values">
                {{ variable.values.join(', ') }}
              </template>
              <template v-if="variable.prefix">{{ variable.prefix }}</template>
              <template v-if="(variable.min || parseInt(variable.min) === 0)">
                {{ variable.min }}
              </template>
              <template
                v-if="
                  (variable.min || parseInt(variable.min) === 0) && variable.max
                "
              >
                -
              </template>
              <template v-if="variable.max">{{ variable.max }}</template>
              <template v-if="variable.suffix">{{ variable.suffix }}</template>
            </span>
            <i
              class="mdi mdi-close-circle-outline pl-1 v2_font_size_18 clickable"
              @click="onRemoveTagClick(qId, vId, false)"
            />
          </span>
        </template>
      </div>
    </template>
    <div class="d-inline">
      <b-button
        variant="v3_link"
        class="v3_color_teal clickable"
        @click="onClearAllClick"
        >
        Clear all Filters
      </b-button
      >
    </div>
  </fragment>
</template>

<script>
export default {
  name: 'SurveyResultTags',
  props: {
    tags: {
      validator: (prop) => typeof prop === 'object' || prop === null,
      default: null,
    },
  },
  methods: {
    onRemoveTagClick: function (qId, vId, isDerived) {
      this.$emit('remove-tag', {
        questionId: qId,
        variableId: vId,
        isDerived,
      });
    },
    onClearAllClick: function () {
      this.$emit('clear-all');
    },
  },
};
</script>

<style scoped></style>
